import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../../context/auth-context';
import { timeRecordingsUrl } from '../../../utils/routes';

function NotAuthGuard(props: { children: any }) {
  const { user } = useContext(AuthContext);

  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate(timeRecordingsUrl);
    }
  }, []);

  return <>{!user && props.children}</>;
}

export default NotAuthGuard;
